import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as FormActions from 'store/forms/actions'
import * as PatientActions from 'store/patients/actions'
import * as UserActions from 'store/user/actions'

import FormType, { formTypeRefs, formTypes } from 'data/questionnaires/FormType'
import IScore from 'data/questionnaires/IScore'
import { get } from 'lodash'
import { RouteComponentProps, withRouter } from 'react-router'
// import { childDataCollected, resultsReadyShown } from 'services/patient'
import { getFormByTypeAndChild } from 'services/questionnaires'
import IForm from '../../data/questionnaires/IForm'

import { TChildListener } from 'components/ChildListener/context'
import { _route } from 'routes/config'
import Content from './content'

import './style.scss'

interface INativeProps {
  childListener?: TChildListener
}
interface IReduxStateProps {
  userAuth?: any
  users?: any[]
  currentPatient?: any
  user: any
  forms: { [type: string]: IForm[] }
  plusUser: any
}

interface IReduxDispatchProps {
  PatientsLib: any
  UserLib: any
  FormLib: any
}

interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

export interface IProps
  extends INativeProps,
    IReduxProps,
    RouteComponentProps {}

export interface IState {
  completedForms: IForm[]
  newForms: IForm[]
  users: any[]
  loading: boolean
  isOpenPlusOnlyPopup: boolean
}

export class PatientDetailsForms extends React.Component<IProps, IState> {
  state = {
    completedForms: [],
    newForms: [],
    users: [],
    loading: true,
    isOpenPlusOnlyPopup: false
  }

  createNewForm = () => this.props.history.replace('/questionnaires/add')

  showAnswerView = () => this.props.history.replace('/answer_view')

  openPlusOnlyPopup = () => {
    this.setState({ isOpenPlusOnlyPopup: true })
  }

  closePlusOnlyPopup = () => {
    this.setState({ isOpenPlusOnlyPopup: false })
  }

  componentDidMount() {
    window.scrollTo(0, 0)

    // don't show currentPatient data from localstorage if user just pasted link for user and localstorage isn't clean because on turn on listener it will make the request
    if (this.props.currentPatient && this.props.childListener) {
      this.getForms()
    }

    // * disable updating child (use less data), testing uncomment if cause some problems
    // PatientsLib.updateCurrentPatient()
  }

  componentDidUpdate(prevProps: IProps) {
    const { currentPatient } = this.props
    const { currentPatient: prevCurrentPatient } = prevProps

    if (currentPatient) {
      if (currentPatient.assessments !== prevCurrentPatient?.assessments) {
        this.getForms()
      }
    }
  }

  getForms = async () => {
    const { currentPatient, forms, FormLib } = this.props
    const currentAssessment = currentPatient && currentPatient.currentAssessment

    if (!currentAssessment) {
      this.setState({ loading: false })
      return
    }

    const assessment = currentPatient.assessments[currentAssessment] || {}
    const completedForms: IForm[] = []
    const newForms: IForm[] = []

    for (const key of formTypes) {
      const score = get(assessment, formTypeRefs[key]) as IScore
      const form = await getFormByTypeAndChild(key, currentPatient, {
        storage: forms,
        Lib: FormLib
      })

      if (form) {
        if (
          get(score, ['total_results', 'total_score', 'score']) !== undefined
        ) {
          completedForms.push(form)
        } else {
          newForms.push(form)
        }
      }
    }

    this.setState({
      completedForms,
      newForms: newForms.sort((a, b) => {
        return a.type === FormType.selfEsteem
          ? -1
          : b.type === FormType.selfEsteem
          ? 1
          : 0
      }),
      loading: false
    })
  }

  goBackAction = () => {
    this.props.history.push(_route.child.list)
  }

  render() {
    const {
      completedForms,
      newForms,
      loading,
      isOpenPlusOnlyPopup
    } = this.state
    const { user, currentPatient } = this.props
    const patientId = get(currentPatient, 'patientId')
    const isPlusUser = this.props.plusUser
    const goToPlus = () => {
      this.props.history.push(_route.payment, { canGoBack: true })
    }

    return (
      <Content
        patientId={patientId}
        patientDetail={currentPatient}
        completed={completedForms}
        pending={newForms}
        loading={loading}
        createNewForm={this.createNewForm}
        showAnswerView={this.showAnswerView}
        role={user.role}
        getForms={this.getForms}
        history={this.props.history}
        goBackAction={this.goBackAction}
        formsStarted={currentPatient?.formsStarted}
        formsFinished={currentPatient?.formsFinished}
        isPlusUser={isPlusUser}
        goToPlus={goToPlus}
        openPlusOnlyPopup={this.openPlusOnlyPopup}
        isOpenPlusOnlyPopup={isOpenPlusOnlyPopup}
        closePlusOnlyPopup={this.closePlusOnlyPopup}
        setInRow={callback =>
          this.props.PatientsLib.UpdateQuestionnarie(true, () => {
            callback()
          })
        }
      />
    )
  }
}

const mapStateToProps = (state): IReduxStateProps => {
  return {
    userAuth: state.user.auth,
    user: state.user.data,
    users: state.user.users,
    currentPatient: state.patients.currentPatient,
    forms: state.forms.allForms,
    plusUser: state.plus_user.isPlusUser
  }
}

const mapDispatchToProps = (dispatch): IReduxDispatchProps => {
  return {
    UserLib: bindActionCreators<any, any>(UserActions, dispatch),
    PatientsLib: bindActionCreators(PatientActions, dispatch),
    FormLib: bindActionCreators(FormActions, dispatch)
  }
}

const WithRouter = withRouter(PatientDetailsForms)

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter)



// WEBPACK FOOTER //
// ./src/pages/EvaluationQuestionnaires/index.tsx